import axios from 'axios';
import { BACKEND_ENDPOINT } from './config/authConfig';

const API_BASE_URL = `${BACKEND_ENDPOINT}/api`; // Update with your real backend URL in production

// Fetch all chat sessions
export const fetchSessions = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/sessions`, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data.sessions;
  } catch (error) {
    console.error("Error fetching sessions", error);
    return [];
  }
};

// Fetch chat history for a session
export const fetchChatHistory = async (sessionId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/chat-history`, {
      params: { sessionId },
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data.messages;
  } catch (error) {
    console.error(`Error fetching chat history for ${sessionId}`, error);
    return [];
  }
};

// Send a message to the AI backend
export const OLD_sendMessage = async (sessionId, message, options = {}) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/send-message`, {
      sessionId,
      message,
      options
    });
    return response.data;
  } catch (error) {
    console.error("Error sending message", error);
    return { text: "Error communicating with AI" };
  }
};

// Send a message to the AI backend
export const newChat = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/create-session`,
      { name: 'New Chat Session' },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating a new chat session:', error);
  }
};

export const removeSession = async (sessionId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/delete-session`, {
      params: { sessionId },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting session:', error);
  }
};

export const renameSession = async (sessionId, newName) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/rename-session`, 
      { sessionId, newName  },{
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error renaming session:', error);
  }
};

export const duplicateSession = async (sessionId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/duplicate-session`, 
      { sessionId },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error duplicating session:', error);
  }
};

export const sendMessage = async (sessionId, message, options = {}) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/send-message`,
      {
        sessionId,
        message,
        options,
      },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
  }
};

export const messageAction = async (sessionId, uid, action) => {
  try {
    const payload = { 
      action: String(action), 
      uid: String(uid),
      sessionId: String(sessionId),
    };
    console.log('Sending payload:', payload);

    const response = await axios.post(
      `${API_BASE_URL}/message-action`,
      payload,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Axios error:', error);
  }
};